<template>
  <div class="form-group">
    <div class="flex items-center">
      <div class="mr-2">
        <h4>{{ index }})</h4>
      </div>
      <div v-if="index == 4">
        <img src="./public/images/emoji-satisfied.svg" />
      </div>
      <div v-if="index == 3">
        <img src="./public/images/emoji-slightly-smiling-face.svg" />
      </div>
      <div v-if="index == 2">
        <img src="./public/images/emoji-neutral-face.svg" />
      </div>
      <div v-if="index == 1">
        <img src="./public/images/emoji-frowning-face.svg" />
      </div>
      <div>
        <p class="text-xl mx-1 my-10">
          {{ capitalizeString(item.emojiName) }}
        </p>
      </div>
    </div>
    <div class="inline-style">
      <div>Subtitles:</div>
      <div class="form-group">
        <div
          v-for="(subtitles, index) in item.subtitles"
          :key="index"
          class="mx-5 my-2"
        >
          <textarea
            v-model="item.subtitles[index]"
            type="text"
            class="resize border rounded focus:outline-none"
            cols="60"
            rows="2"
          />
        </div>
      </div>
      <div>Tags:</div>
      <div class="form-group">
        <div
          v-for="(tags, index) in item.tags"
          :key="index"
          class="w-3/5 flex items-center px-4"
        >
          <input
            v-model="item.tags[index]"
            type="text"
            class="input-box-course-creators"
          />
          <button
            class="btn btn-red col-sm-2"
            style="padding:mx-0;background:red"
            @click.prevent="removeTag(index)"
          >
            remove
          </button>
        </div>
        <button class="btn btn-red" @click.prevent="addTags">
          add tag
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["index", "item"],
  data() {
    return {
      subtitleOptions: this.item.subtitles,
      tagOptions: [],
    }
  },
  methods: {
    removeTag(index) {
      this.item.tags.splice(index, 1)
    },
    addTags() {
      this.item.tags.push("Add a new tag")
    },
    capitalizeString(str) {
      return (
        str.substring(0, 1).toUpperCase() + str.substring(1, str.length)
      ).replace(/-/g, " ")
    },
  },
}
</script>

<style scoped>
.btn {
  width: 100px;
  height: auto;
  margin: 10px;
  padding: 5px;
  border-radius: 10px;
  color: white;
  background-color: #39be70;
  box-shadow: 0 2px 3px 0 #575757;
  text-shadow: none;
  font-weight: 500;
}
img {
  width: 2em;
  height: 3em;
  margin-top: -3px;
}
</style>
